// BSC Mainnet 配置
export const CHAIN_ID = 56;
export const RPC_URL = 'https://bsc-dataseed.binance.org/';

// 合约地址 - 请根据实际情况修改
// export const TOKEN_ADDRESS = '0xfC49A4ed326675b3496c8d94d68fbF4FFa8De85A';
// export const MINING_ADDRESS = '0xbfF84cba074Dd0B8C591a9de7e91C5CAb54fE282';
export const TOKEN_ADDRESS = '0xDb23D5Fe0161B3163156D966f09c807e0d68C802';
export const MINING_ADDRESS = '0x735CA83dC9515D7c03BeE3De17CAA8bd163ff851';
// 网络名称映射
export const NETWORK_NAMES = {
    56: 'BSC Mainnet',
    97: 'BSC Testnet',
    1: 'Ethereum Mainnet'
};

// 节点等级配置
export const NODE_LEVELS = [
    { value: 0, label: '无等级' },
    { value: 1, label: 'V1' },
    { value: 2, label: 'V2' },
    { value: 3, label: 'V3' },
    { value: 4, label: 'V4' },
    { value: 5, label: 'V5' },
    { value: 6, label: 'V6' }
];

// 有效期选项（月）
export const EXPIRE_MONTHS = [
    { value: 1, label: '1个月' },
    { value: 3, label: '3个月' },
    { value: 6, label: '6个月' },
    { value: 12, label: '12个月' },
    { value: 24, label: '24个月' },
    { value: 36, label: '36个月' }
];